import { Box, Button, SimpleGrid, Text, useMediaQuery } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { RiArrowUpDownLine } from "react-icons/ri";
import { useParams } from "react-router-dom";
import FetchData from "../../services/FetchData";
import PerusahaanCard from "../card/PerusahaanCard";
import Pagination from "../utilities/Pagination";

import Perusahaan from "../../assets/default/perusahaan.png";

export default function SectionPerusahaan() {
  const { keyword } = useParams();
  const [mobile] = useMediaQuery("(max-width: 600px)");

  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);

  const { data } = FetchData({
    url: "/sellers",
    params: { keyword: keyword, page: page },
  });

  const handlePage = (item) => {
    setPage(item);
    setCount(count + 1);
  };

  console.log(data);
  return (
    <Box px={mobile ? "5" : "40"} py={mobile ? "2" : "10"}>
      <Box display="flex" alignItems="center">
        <Box display="flex" width="full">
          <Text fontSize={mobile ? "16" : "28"} fontWeight="500">
            Perusahaan Penyedia MBLB
          </Text>
        </Box>
        {/* <Button
          variant="ghost"
          disabled
          display="flex"
          width="30"
          alignItems="center"
        >
          <Text fontSize="16" fontWeight="400" width="16">
            Sort By
          </Text>
          <RiArrowUpDownLine />
        </Button> */}
      </Box>
      <SimpleGrid
        columns={[2, 2, null, 3, null, 5]}
        spacing={mobile ? 2 : 10}
        py={mobile ? "2" : "10"}
      >
        {data?.sellers.map((item) => (
          <PerusahaanCard
            nama={item.company}
            kecamatan={item.address}
            id={item.seller_id}
            image={Perusahaan}
          />
        ))}
      </SimpleGrid>
      {data?.sellers.length === 0 && (
        <Text textAlign="center" fontWeight="700" fontSize="20">
          Data tidak ditemukan
        </Text>
      )}
      <Pagination
        page={page}
        handlePage={handlePage}
        totalPage={data?.total_page}
      />
    </Box>
  );
}
